import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ValidatorFn, Validators } from '@angular/forms';
import {DocumentTemplateService} from '../../../services/document-template.service';
import { DocumentTemplate } from '../../../models/document-template.model';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import {EditorModule} from 'primeng/editor';
import { SharedService } from '../../../../shared/services/shared.service';
import { User } from '../../../../../../src/app/auth/models';

@Component({
  selector: 'app-document-template-add',
  templateUrl: './document-template-add.component.html',
  styleUrls: ['./document-template-add.component.css']
})
export class DocumentTemplateAddComponent implements OnInit {
  documentTemplateAddForm:FormGroup;
  loggedInUserProfile: User;
  tempid: number =0;
  constructor(
    private documentTemplateService:DocumentTemplateService,
    private router: Router,private route: ActivatedRoute,
    private _fb: FormBuilder,
    public sharedService: SharedService
  ) { }

  ngOnInit(): void {

    this.checkViewPermission();
    this.InitialSetup();
    this.route.queryParams
      .subscribe(params => {
        console.log(params);
        this.tempid = params.id;
        console.log("id value is "+this.tempid);
      }
    );

    if(this.tempid>0)
    {
      this.documentTemplateService.getDocumentTemplateById(this.tempid).subscribe((data:DocumentTemplate) =>{
      this.documentTemplateAddForm.patchValue(data);
      },error => {
         console.log(error)
       })
    }

  }
  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this.router.navigateByUrl('/login');
  }
  InitialSetup(){
    this.documentTemplateAddForm = this._fb.group({
      docTemplateId: new FormControl(0,[Validators.required]),
      templateName: new FormControl("",[Validators.required]),
      screenName:new FormControl("",[Validators.required]),
      description: new FormControl("",[Validators.required]),
      isActive: new FormControl(false,[Validators.required]),
      createdBy: new FormControl(""),
      createdOn: new FormControl(""),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl("")
    })
  }

  editorMaxLength(maxlength): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      var regex = /(<([^>]+)>)/ig;
      var value = control.value;
      if (value == null) {
        return null;
      }
      var result = value.replace(regex, "");
      if (result.length > maxlength) {
        return { 'maxlengthError': true };
      }else{
        return null;
      }
    }
  }

  save({value}: {value: DocumentTemplate}){
    console.log(value);
    //if(value.TemplateId == 0){
    if(this.tempid==undefined){
      //value.createdBy = 1;
      this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
      value.createdBy = Number (this.loggedInUserProfile.uid);
      value.createdOn = new Date();
      value.Description=this.documentTemplateAddForm.get('description').value.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, " ");
      this.documentTemplateService.postDocumentTemplate(value).subscribe(data => {
        this.router.navigate(['/document-template']);
      }, error => {
        console.log(error)
      })
    }
    else{
      value.docTemplateId=this.tempid;
      value.Description=this.documentTemplateAddForm.get('description').value.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, " ");
      this.documentTemplateService.updateDocumentTemplate(value.docTemplateId, value).subscribe(data => {
        this.router.navigate(['/document-template']);
      }, error => {
      console.log(error);
      })
    }
  }
  cancel()
  {
    this.router.navigate(['/document-template']);
  }

}
